'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasMessagesLockAccess = exports.hasMessagesChatAccess = exports.hasMessagesWriteAccess = exports.hasMessagesReadAccess = exports.getScopes = exports.getUserId = exports.mapUserToDisplayName = exports.getUser = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _reselect = require('reselect');

var _Scopes = require('conversations-core/constants/Scopes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUser = exports.getUser = (0, _getIn2.default)(['auth', 'user']);

var mapUserToDisplayName = exports.mapUserToDisplayName = (0, _reselect.createSelector)([getUser], function (user) {
  var firstName = user.get('first_name');
  return '' + firstName;
});

var getUserId = exports.getUserId = (0, _reselect.createSelector)(getUser, (0, _get2.default)('user_id'));
var getScopes = exports.getScopes = (0, _reselect.createSelector)(getUser, (0, _get2.default)('scopes'));

var hasMessagesReadAccess = exports.hasMessagesReadAccess = (0, _reselect.createSelector)(getScopes, function (scopes) {
  return scopes.includes(_Scopes.MESSAGES_READ);
});

var hasMessagesWriteAccess = exports.hasMessagesWriteAccess = (0, _reselect.createSelector)(getScopes, function (scopes) {
  return scopes.includes(_Scopes.MESSAGES_WRITE);
});

var hasMessagesChatAccess = exports.hasMessagesChatAccess = (0, _reselect.createSelector)(getScopes, function (scopes) {
  return scopes.includes(_Scopes.MESSAGES_CHAT);
});

var hasMessagesLockAccess = exports.hasMessagesLockAccess = (0, _reselect.createSelector)(getScopes, function (scopes) {
  return scopes.includes(_Scopes.MESSAGES_LOCK);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/selectors/userSelectors.js
// module id = 70
// module chunks = 0 1